import Anamnesi from "../"

const routes = [
    { name: "AnamnesiList", path: "/paziente/anamnesi/", component: Anamnesi.AnamnesiListPage, meta: { title: "Anamnesi" } },
    { name: "AnamnesiEdit", path: "/paziente/anamnesi/edit/:id", component: Anamnesi.AnamnesiEditPage, meta: { title: "Anamnesi" } },
    { name: "AnamnesiView", path: "/paziente/anamnesi/view/:id", component: Anamnesi.AnamnesiViewPage, meta: { title: "Anamnesi" } },
]

export default routes;